import HomeBanner1 from "../ones/HomeBanner1";
import CallToAction from "../ones/callToAction";
import Footer from "../ones/Footer";
import HomeAboutSection from "../ones/HomeAboutSection";
import HomeProjectSection from "../ones/HomeProjectSection";
import HomeServicesContent from "../ones/HomeServicesContent";

export default function HomeLanding() {
  return (
    <>
      <HomeBanner1 />
      <HomeServicesContent />
      <HomeProjectSection />
      <HomeAboutSection />
      <CallToAction />
      <Footer />
    </>
  );
}
